import axios from "axios";
import { getJwtToken } from "../../Auth0/SessionProvider";
import { getBaseUrl,getBhoomiURL } from "../../utils/commonUtil";
import { isGeminiUser } from "../../utils/sessionUtil";
import jwt_decode from 'jwt-decode';

const CancelToken = axios.CancelToken;
let cancel;

const makeRequest = async (url, config, data, method='get',isBhoomiUrl=false) => {
  let { headers } = config;  
  const token = await getJwtToken();
  if(!isBhoomiUrl)
  {
    headers['Authorization'] = `Bearer ${token}`;
  }
  else {
    headers['authtoken'] = token;
    config.withCredentials = true;
    config.auth = {
      username:process.env.REACT_APP_BHOOMI_USERNAME,
      password:process.env.REACT_APP_BHOOMI_PASSWORD
    }
    headers["application"] = isGeminiUser()?"GDP":"DP";
  }
  config['headers'] = headers;
  //Added below code snippet to add party id to getUserInfo api url for Appd logging purpose.
  if(url.includes('/donor-portal/api/user/null/getUserInfo')) {
    let decoded = jwt_decode(token);    
    let key = `${process.env.REACT_APP_AUTH0_AUDIENCE}partyId`;
    if(decoded.hasOwnProperty(key)) {
      url = url.replace(null, decoded[key]);
    }    
  }

  if(token) {
    if(method === 'get') {
      return await axios.get(url, config);
    }
    else if(method === 'post') {
      return await axios.post(url, data, config);
    }
    else if(method === 'put') {
      return await axios.put(url, data, config);
    }
  }
}

export default {
  init(opts) {
    let baseUrl = getBaseUrl();
    let bhoomiBaseURL =  getBhoomiURL();
    const headerConfig = {
      "Content-Type": "application/json;charset=UTF-8",      
      "Access-Control-Allow-Origin": "*",
    };

    return {
      request(
        url,
        method,
        queryParams,
        data,
        contentType,
        isExternal,
        externalHeader,
        canCancel,
        isBhoomiUrl= false
      ) {
        if (!url) throw new Error("Request - URL not defined");
        if (!contentType) contentType = "application/json";
        if (!queryParams) queryParams = {};
        if (!data) data = {};
        if(isBhoomiUrl)
        {
          url = bhoomiBaseURL+url;
        }
        else
        { if (isExternal) {
          let baseUrl = "";
          url = baseUrl + url;
        } else {
          url = baseUrl + url;
        }

      }
        switch (method) {
          case "GET":
            return this.get(url, queryParams, data ,contentType,canCancel,isBhoomiUrl);
          case "POST":
            return this.post(
              url,
              queryParams,
              data,
              contentType,
              externalHeader,
              isBhoomiUrl
            );
          case "PUT":
            return this.put(url, queryParams, data, contentType);
          case "DELETE":
            return this.del(url, queryParams, data, contentType);
          case "FORMDATA": return this.formDataRequest(url,data);
          default:
            throw new Error("Request method not defined");
        }
      },
      get(url, queryParams, data, contentType,canCancel, isBhoomiUrl) {
        if(canCancel){
          cancel()
        }
        const config = {
          headers: headerConfig,
          cancelToken:new CancelToken(function executor(c) {

            cancel = c;
          })
        };
        const json_data = JSON.stringify(data);
        return makeRequest(url, config, '','get',isBhoomiUrl);
      },
      post(url, queryParams, data, contentType, externalHeader,isBhoomiUrl) {
        const config = {
          headers: headerConfig
        };
        if (externalHeader) {
          config.headers = { ...config.headers, ...externalHeader };
        }
        const json_data = JSON.stringify(data);
        return makeRequest(url, config, json_data, 'post',isBhoomiUrl
        );
      },
      put(url, queryParams, data, contentType, externalHeader) {
        const config = {
          headers: headerConfig
        };
        if (externalHeader) {
          config.headers = { ...config.headers, ...externalHeader };
        }
        const json_data = JSON.stringify(data);
        return makeRequest(url, config, json_data, 'put');
      },
      del(url, queryParams, contentType) { },
      url() {
        return baseUrl;
      },
      customRequest(url, queryParams, contentType) { },
      formDataRequest(url, queryParams) {
        const fd = new FormData();
        for (const key of Object.keys(queryParams)) {
          fd.append(key, queryParams[key]);
        }
        const config = {
          headers: headerConfig
        };
        return makeRequest(url, config, fd, 'post');
      }
    };
  }
};